import {useDialogContext} from "../../dialogs/hooks/useDialogContext";

export const useImportProjectTranslationsDialog = () => useDialogContext('import-translations');